var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        "cancel-variant": "outline-secondary",
        centered: "",
        "ok-title": "적용",
        "cancel-title": "취소",
        size: "lg",
        title: "인증정보요청 API 전송 항목",
        "no-close-on-esc": "",
        "no-close-on-backdrop": "",
      },
      on: {
        ok: function ($event) {
          $event.preventDefault()
          return _vm.submit()
        },
        close: function ($event) {
          $event.preventDefault()
          return _vm.close()
        },
        cancel: function ($event) {
          $event.preventDefault()
          return _vm.close()
        },
      },
      model: {
        value: _vm.showSignatureForm,
        callback: function ($$v) {
          _vm.showSignatureForm = $$v
        },
        expression: "showSignatureForm",
      },
    },
    [
      _c(
        "b-row",
        { staticClass: "mt-1" },
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "b-form-checkbox-group",
                {
                  attrs: { "value-field": "code", "text-field": "label" },
                  model: {
                    value: _vm.selects,
                    callback: function ($$v) {
                      _vm.selects = $$v
                    },
                    expression: "selects",
                  },
                },
                _vm._l(_vm.codes.forms, function (f) {
                  return _c(
                    "b-form-checkbox",
                    {
                      key: f.code,
                      staticClass: "mb-25 mr-3",
                      staticStyle: { width: "120px" },
                      attrs: { value: f.code },
                    },
                    [_vm._v(" " + _vm._s(f.label) + " ")]
                  )
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }